import React, { FC } from "react";
import Image from "next/image";

import styles from "./ReviewCard.module.css";
import { StarSolid } from "../../icons";

type ReviewCardImage = {
  url?: string | null;
  description?: string | null;
  width?: number | null;
  height?: number | null;
} | null;

export type ReviewCardProps = {
  avatar: ReviewCardImage;
  reviewText: string | null;
  authorName: string | null;
  authorSubtitle?: string | null;
};

export const ReviewCard: FC<ReviewCardProps> = ({
  avatar,
  reviewText,
  authorName,
}) => {
  return (
    <div className={styles.card}>
      <div className={styles.stars} aria-label="5 out of 5 stars">
        {[0, 1, 2, 3, 4].map((i) => (
          <StarSolid size={24} key={i} className={styles.star} />
        ))}
      </div>
      {reviewText && <p className={styles.reviewText}>{reviewText}</p>}
      <div className={styles.author}>
        {avatar?.url && (
          <Image
            src={avatar.url}
            alt={avatar.description ?? ""}
            width={32}
            height={32}
            className={styles.avatar}
          />
        )}
        {authorName && <p className={styles.authorName}>{authorName}</p>}
      </div>
    </div>
  );
};
